import { render } from "./Empty.vue?vue&type=template&id=34fb82c4&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"

import "./Empty.vue?vue&type=style&index=0&id=34fb82c4&scoped=true&lang=css"

import exportComponent from "E:\\Project Repository\\11-Isomat\\code\\services\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fb82c4"]])

export default __exports__